


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProjectOverviewItem } from '@/interfaces/ProjectOverviewItem';

@Component
export default class OverviewTable extends Vue {
    @Prop({
        required: true,
    })
    protected projectOverviewItem!: ProjectOverviewItem;
    @Prop({
        required: true,
    })
    protected tableLabel!: string;
}
